import type { TFunction } from "i18next";
import { ServiceCategory } from "../../autogen/bff-api";

export const SERVICE_CATEGORIES: ReadonlyArray<ServiceCategory> = [
  ServiceCategory.Ordinary,
  ServiceCategory.SpecialServices,
  ServiceCategory.HealthSocialEducation,
];

export const serviceCategoryLabel = (
  t: TFunction,
  category: ServiceCategory,
  underUtilities: boolean | null,
): string => {
  switch (category) {
    case ServiceCategory.Ordinary:
      return t("Ordinary service");
    case ServiceCategory.SpecialServices:
      if (underUtilities === null) return t("Special services");
      return underUtilities ? t("Special services (Utilities Regulation Annex 3)") : t("Special services (FOA Annex 2)");
    case ServiceCategory.HealthSocialEducation:
      if (underUtilities === null) return t("Health, social and education services");
      return underUtilities
        ? t("Health, social and education services (Utilities Regulation Annex 4)")
        : t("Health, social and education services (FOA Annex 3)");
  }
};
